import { api } from './baseApi';
import { GenerateReportFormValues } from '@/types/report.types';
import { formatDateForBackend } from '@/utils/date.utils';
import { HttpStatus } from '@/types/http-status.types';

/**
 * Interface for generate report request body
 */
export interface GenerateReportRequest {
  Type: string;
  LocationIds: string[];
  Recipients: string;
  StartDate: string;
  EndDate: string;
}

/**
 * Interface for generate report response
 */
export interface GenerateReportResponse {  
}

/**
 * Reports API service
 */
export const reportsApi = {  
  generateReport: async (data: GenerateReportFormValues): Promise<GenerateReportResponse> => {
    if (!data.startDate || !data.endDate) {
      throw new Error('Start date and end date are required');
    }

    const response = await api.post<void>(
      '/merchant/reports/generate', 
      {
        type: data.reportType,
        locationIds: data.locationIds,
        recipients: data.emailTo,
        startDate: formatDateForBackend(data.startDate),
        endDate: formatDateForBackend(data.endDate),
      },
      {        
        skipSentryLogging: [HttpStatus.NOT_FOUND, HttpStatus.UNPROCESSABLE_ENTITY],
      }
    );
    
    return response;
  },
}; 